import { Categoria } from '../services/types';

export interface HierarchicalCategoria extends Categoria {
    level: number;
    isParent: boolean;
    hasChildren: boolean;
    parentName?: string;
}

export const getHierarchicalCategories = (categorias: Categoria[]): HierarchicalCategoria[] => {
    const map = new Map<number, Categoria>();
    const roots: Categoria[] = [];
    const parentIds = new Set<number>();

    // Build map and identify parents that have children
    categorias.forEach(cat => {
        map.set(cat.id, cat);
        if (cat.categoria_pai_id) {
            parentIds.add(cat.categoria_pai_id);
        }
    });

    categorias.forEach(cat => {
        if (!cat.categoria_pai_id) {
            roots.push(cat);
        }
    });

    // Sort roots alphabetically
    roots.sort((a, b) => a.nome.localeCompare(b.nome));

    const result: HierarchicalCategoria[] = [];

    const traverse = (cat: Categoria, level: number, parentName?: string) => {
        const hasChildren = parentIds.has(cat.id);
        // Root categories (level === 0) are always parent groups; items must be assigned to subcategories (level > 0)
        const isParent = level === 0 || hasChildren;
        result.push({ ...cat, level, isParent, hasChildren, parentName });

        // Find children
        const children = categorias
            .filter(c => c.categoria_pai_id === cat.id)
            .sort((a, b) => a.nome.localeCompare(b.nome));

        children.forEach(child => traverse(child, level + 1, cat.nome));
    };

    roots.forEach(root => traverse(root, 0));

    return result;
};
